import { useState } from 'react';
import { Button } from 'src/components/system/Button';
import { Page, Card, Title, Input, ErrorText } from './styles';
import { changePassword } from 'src/services/auth';

export function ChangePassword() {
  const [current_password, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [password_confirmation, setPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');
    try {
      const res = await changePassword(current_password, password, password_confirmation);
      setMessage(res.status || 'Senha alterada com sucesso.');
    } catch (err: any) {
      setError('Não foi possível alterar a senha.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Page>
      <Card>
        <Title>Alterar senha</Title>
        <form onSubmit={onSubmit}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Input placeholder="Senha atual" type="password" value={current_password} onChange={e => setCurrent(e.target.value)} required />
            <Input placeholder="Nova senha" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            <Input placeholder="Confirmar senha" type="password" value={password_confirmation} onChange={e => setPasswordConfirmation(e.target.value)} required />
            {message && <div>{message}</div>}
            {error && <ErrorText>{error}</ErrorText>}
            <Button
              width="100%"
              backgroundColor="#222B82"
              borderColor="#222B82"
              buttonColor="#fff"
              type="submit"
              disabled={loading}
              label={<span>{loading ? 'Salvando...' : 'Salvar'}</span>}
            />
          </div>
        </form>
      </Card>
    </Page>
  );
}

